import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Npm = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Npm' {...props}>
    <g fill='none' fillRule='evenodd'><rect width='24' height='24' fill='#D40001' /><path fill='#FFF' d='M16.7179487,7.92840493 L12.2051282,7.92840493 L12.2051282,20.2494172 L4,20.2494172 L4,3 L12.2051282,3 L20,3 L20,7.92840493 L20,20.2494172 L16.7179487,20.2494172 L16.7179487,7.92840493 Z' /></g>
  </StyledIcon>
);
